import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ghatkopartopunecabservice() {



  const cardData = {


  keyword: "Ghatkopar to Pune Cab Service",

  headingDescription: "Trustline Cab provides reliable Ghatkopar to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained cars, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Ghatkopar to Pune taxi services.",

  topPlaces: [
    {
      title: "Kalyani Nagar",
      description: "Kalyani Nagar is one of Pune's premium business and residential destinations, known for corporate offices, IT companies, luxury hotels, shopping centers, and fine dining restaurants. It is a preferred location for business executives and visitors."
    },
    {
      title: "Baner",
      description: "Baner is a thriving commercial and residential locality featuring IT companies, business parks, cafés, educational institutions, and premium housing developments. It is one of Pune's fastest-growing corporate destinations."
    },
    {
      title: "Hadapsar",
      description: "Hadapsar is a major commercial hub known for Magarpatta City, IT parks, corporate offices, educational institutions, and excellent road connectivity. It is a popular destination for professionals and business travelers."
    },
    {
      title: "Bhosari MIDC",
      description: "Bhosari MIDC is one of Pune's largest industrial zones, housing engineering companies, automobile manufacturers, industrial units, and logistics businesses. It is a key destination for industrial and corporate travel."
    },
    {
      title: "Talegaon MIDC",
      description: "Talegaon MIDC is a rapidly expanding industrial area with manufacturing plants, automobile companies, warehouses, and logistics hubs. It attracts corporate visitors and industrial professionals from Mumbai."
    },
    {
      title: "Kondhwa",
      description: "Kondhwa is a well-developed residential and commercial locality offering business establishments, hospitals, educational institutions, shopping centers, and excellent connectivity across Pune."
    },
    {
      title: "Shinde Chhatri",
      description: "Shinde Chhatri is a magnificent historical monument known for its elegant architecture, intricate carvings, and cultural importance. It is a popular attraction for history enthusiasts visiting Pune."
    },
    {
      title: "Pashan Lake",
      description: "Pashan Lake is a peaceful natural attraction surrounded by greenery and walking trails. It is an ideal destination for birdwatching, photography, and relaxing outdoor visits."
    },
    {
      title: "Lavasa",
      description: "Lavasa is a scenic planned hill city near Pune, famous for its lakeside promenade, colorful architecture, adventure activities, and peaceful surroundings. It is a popular weekend getaway."
    },
    {
      title: "Tikona Fort",
      description: "Tikona Fort is a historic hill fort near Pawna Lake, offering panoramic views, trekking trails, and rich Maratha history. It is a favorite destination for trekkers, photographers, and nature lovers."
    }
  ],






"services": [
  {
    "name": "Ghatkopar to Pimple Saudagar Cabs",
    "description": "Book Ghatkopar to Pimple Saudagar Cabs for comfortable, safe, and affordable intercity travel with experienced chauffeurs, clean AC Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles. Enjoy doorstep pickup, transparent pricing, luggage assistance, flexible travel schedules, and 24x7 customer support for business trips, family travel, airport transfers, and outstation journeys."
  },
  {
    "name": "Ghatkopar to Pune One Way Cab",
    "description": "Choose Ghatkopar to Pune One Way Cab for hassle-free travel with fixed fares, professional drivers, sanitized vehicles, comfortable seating, and timely pickup. Perfect for corporate travel, personal trips, family vacations, and convenient one-way transportation to Pune."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Book Pune to Mumbai Taxi Service with reliable chauffeur-driven vehicles, affordable pricing, multiple car options including Sedan, Ertiga, Innova Crysta, and SUVs. Get on-time pickup, smooth highway travel, and dependable service for business, airport, and leisure trips."
  },
  {
    "name": "Ghatkopar to Pune Baner Taxi Fare",
    "description": "Check Ghatkopar to Pune Baner Taxi Fare with transparent pricing, fixed packages, no hidden charges, and multiple vehicle choices for comfortable and affordable travel to Baner and nearby Pune locations."
  },
  {
    "name": "Ghatkopar to Kondhwa Pune Taxi",
    "description": "Reserve Ghatkopar to Kondhwa Pune Taxi with experienced drivers, premium AC vehicles, doorstep pickup, flexible travel timing, and reliable intercity transportation for families, professionals, and corporate travelers."
  },
  {
    "name": "Mumbai Ghatkopar to Pune Taxi Fare",
    "description": "Get affordable Mumbai Ghatkopar to Pune Taxi Fare with fixed pricing, comfortable AC cars, professional chauffeurs, and safe travel for one-way and round-trip journeys."
  },
  {
    "name": "Ghatkopar to Pune AC Cab Service",
    "description": "Travel with Ghatkopar to Pune AC Cab Service using well-maintained air-conditioned cars, experienced drivers, spacious luggage capacity, and comfortable seating for business, family, and airport travel."
  },
  {
    "name": "Ghatkopar to Pune Innova Cab",
    "description": "Book Ghatkopar to Pune Innova Cab for spacious and comfortable travel with professional chauffeurs, ideal for families, corporate groups, and passengers carrying extra luggage on long-distance journeys."
  },
  {
    "name": "Ghatkopar to Pune Taxi Fare",
    "description": "Check Ghatkopar to Pune Taxi Fare with transparent rates, affordable pricing, multiple cab options, and dependable service for convenient outstation travel."
  },
  {
    "name": "Ghatkopar East to Pune Cab",
    "description": "Reserve Ghatkopar East to Pune Cab with doorstep pickup, clean AC vehicles, courteous drivers, fixed pricing, and 24x7 booking support for safe and comfortable travel."
  },
  {
    "name": "Ghatkopar West to Pune Cab",
    "description": "Book Ghatkopar West to Pune Cab for reliable intercity transportation with premium vehicles, experienced chauffeurs, on-time pickup, and affordable fares for every journey."
  },
  {
    "name": "Ghatkopar to Pune Round Trip Cabs",
    "description": "Choose Ghatkopar to Pune Round Trip Cabs with flexible return timing, fixed round-trip packages, comfortable AC vehicles, and professional drivers for business visits, family functions, and weekend travel."
  },
  {
    "name": "Ghatkopar to Pune Cab Per Km Rate",
    "description": "Get Ghatkopar to Pune Cab Per Km Rate with transparent billing, competitive pricing, multiple vehicle categories, and no hidden charges for affordable intercity cab travel."
  },
  {
    "name": "Ghatkopar to Pune Sedan Taxi",
    "description": "Book Ghatkopar to Pune Sedan Taxi featuring clean, fuel-efficient AC sedans with experienced drivers, comfortable seating, and affordable pricing for solo travelers, couples, and business professionals."
  },
  {
    "name": "Ghatkopar to Pune Innova Crysta Cab",
    "description": "Hire Ghatkopar to Pune Innova Crysta Cab for premium travel with spacious seating, luxury interiors, professional chauffeurs, ample luggage space, and comfortable transportation for families, corporate teams, and group travel."
  }
],

"tableData": [
  ["Ghatkopar to Pimple Saudagar Cabs", "Ghatkopar to Pune One Way Cab"],
  ["Pune to Mumbai Taxi Service", "Ghatkopar to Pune Baner Taxi Fare"],
  ["Ghatkopar to Kondhwa Pune Taxi", "Mumbai Ghatkopar to Pune Taxi Fare"],
  ["Ghatkopar to Pune AC Cab Service", "Ghatkopar to Pune Innova Cab"],
  ["Ghatkopar to Pune Taxi Fare", "Ghatkopar East to Pune Cab"],
  ["Ghatkopar West to Pune Cab", "Ghatkopar to Pune Round Trip Cabs"],
  ["Ghatkopar to Pune Cab Per Km Rate", "Ghatkopar to Pune Sedan Taxi"],
  ["Ghatkopar to Pune Innova Crysta Cab", "Ghatkopar to Pune AC Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Ghatkopar to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Ghatkopar to Pune cab services with comfortable vehicles, professional drivers, and hassle-free intercity travel."
  },
  {
    WhyChooseheading: "Convenient Pickup from Ghatkopar",
    WhyChoosedescription: "Enjoy doorstep pickup from Ghatkopar East, Ghatkopar West, railway station, offices, hotels, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Safe Travel",
    WhyChoosedescription: "Our skilled drivers ensure a smooth and secure journey with extensive knowledge of the Mumbai-Pune Expressway and surrounding routes."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit individual, family, or group travel."
  },
  {
    WhyChooseheading: "Competitive Pricing with Full Transparency",
    WhyChoosedescription: "Receive clear fare details before your journey with transparent pricing and no unexpected charges during your trip."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Cab Options",
    WhyChoosedescription: "Book one-way rides, round trips, or personalized travel plans according to your schedule and destination requirements."
  },
  {
    WhyChooseheading: "Suitable for Every Travel Purpose",
    WhyChoosedescription: "Our Ghatkopar to Pune cab service is ideal for business meetings, airport transfers, family travel, educational visits, and leisure trips."
  },
  {
    WhyChooseheading: "24/7 Booking & Customer Assistance",
    WhyChoosedescription: "Our support team is available around the clock to assist with bookings, travel planning, and vehicle selection."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Ghatkopar to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable Ghatkopar to Pune cab services for one-way journeys, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Ghatkopar to Pune?",
    answer: "Yes, one-way cab services are available with convenient pickup from Ghatkopar and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Ghatkopar East and Ghatkopar West?",
    answer: "Yes, we provide doorstep pickup from Ghatkopar East, Ghatkopar West, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Ghatkopar to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Ghatkopar to Pune cab service available 24/7?",
    answer: "Yes, our cab services operate throughout the day and night for flexible travel according to your preferred schedule."
  },
  {
    question: "Can I reserve a return cab from Pune to Ghatkopar?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Ghatkopar."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in the confirmed booking quotation."
  },
  {
    question: "Should I make an advance booking?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup time."
  },
  {
    question: "Do you provide Ghatkopar to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Ghatkopar to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Shinde",
    feedback: "Trustline Travels arranged our Ghatkopar to Pune trip perfectly with a punctual driver, comfortable vehicle, and excellent coordination throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "The entire travel experience was smooth and enjoyable. The booking process was easy, the cab was clean, and the driver ensured a safe and pleasant ride to Pune.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ghatkopar to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/ghatkopar-to-pune-cab-service.webp",
  "description":
    "Book Ghatkopar to Pune Cab Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Ghatkopar to Pune, Pimple Saudagar, Baner, Kondhwa, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/ghatkopar-to-pune-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Ghatkopar to Pune Cab Service | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Ghatkopar to Pune Cab Service with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Ghatkopar to Pune, Pimple Saudagar, Baner, Kondhwa, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Ghatkopar to pimple saudagar cabs, ghatkopar to pune one way cab, pune to mumbai taxi service, ghatkopar to pune baner taxi fare, ghatkopar to kondhwa pune taxi, mumbai ghatkopar to pune taxi fare, mumbai to pune taxi service, Ghatkopar to Pune Cab Service, Ghatkopar Pune Taxi, Ghatkopar to Pune Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/113.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ghatkopartopunecabservice;